import React from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconButton,  } from '@mui/material';
import Styles from "../../Styles/Resume.module.css"
import TopBar from "../../Components/LayoutWapper/Global/TopBar";
import Sidebar from "../../Components/LayoutWapper/Global/SideBar";
import cube from "../../Assets/cube.png"
import nav3 from "../../Assets/nav3.png"






function Index() {

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }


  return  (
      <div className={Styles.container}>
      <TopBar toggleSidebar={toggleSidebar}/>
      <div className={Styles.main} >
       <div className={Styles.context} >
       <div className={Styles.nav}>
       {isSidebarOpen && <Sidebar />}
       </div>
       <div className={Styles.center}>
        <div className={Styles.info}>
        <div className={Styles.Header}>
         <h1>Resumes</h1> 
        </div>
        <div className={Styles.Resume}>
         <div className={Styles.Resumeitem}>
             <div className={Styles.profilecube}  >
              <img src={cube}  alt="" width="48px" height="75px"/>
             </div>
             <div className={Styles.profiletext}  >
               <h3>ReAct Resume</h3>
               <p>Added Feb 20, 2023</p>
            </div>
            <div className={Styles.moreinfo}>
            <IconButton disableRipple><Link to='/resume/ResumeInfo'><img  src={nav3} alt="/" width="10px" height="10px" /></Link></IconButton>
           </div>
           </div> 
         </div>
        </div>
          </div>
          </div>
         </div>
       </div> 
       
      
  )
}

export default Index;